import { Layout as ReactGridLayout } from 'react-grid-layout'
import { localStorageKey } from '../hooks/useLocalStorageState'

interface Layout<TComponent extends string> extends ReactGridLayout {
  i: TComponent
}

export type LayoutComponent =
  | 'tradingview'
  | 'orderbook'
  | 'trade'
  | 'token-change-stats'
  | 'trades-holders'
  | 'user-tabs'
  | 'token-details'
  | 'token-distribution'

export type Layouts = Record<'lg' | 'xl' | 'xxl', Layout<LayoutComponent>[]>

export const BREAKPOINTS = {
  lg: 1024,
  xl: 1280,
  xxl: 1536,
} as const satisfies Record<keyof Layouts, number>

export const COLS = {
  lg: 12,
  xl: 12,
  xxl: 12,
} as const satisfies Record<keyof Layouts, number>

export function makeDefaultLayout() {
  return {
    lg: [
      { i: 'tradingview', x: 0, y: 0, w: 7, h: 16 },
      { i: 'orderbook', x: 7, y: 0, w: 2, h: 16 },
      { i: 'trade', x: 9, y: 0, w: 3, h: 16 },
      { i: 'token-change-stats', x: 0, y: 16, w: 7, h: 6 },
      { i: 'trades-holders', x: 0, y: 22, w: 7, h: 20 },
      { i: 'user-tabs', x: 7, y: 16, w: 5, h: 8 },
      { i: 'token-details', x: 7, y: 24, w: 5, h: 8 },
      { i: 'token-distribution', x: 7, y: 32, w: 5, h: 10 },
    ],
    xl: [
      { i: 'tradingview', x: 0, y: 0, w: 7, h: 16 },
      { i: 'orderbook', x: 7, y: 0, w: 2, h: 16 },
      { i: 'trade', x: 9, y: 0, w: 3, h: 16 },
      { i: 'token-change-stats', x: 0, y: 16, w: 8, h: 6 },
      { i: 'trades-holders', x: 0, y: 22, w: 8, h: 20 },
      { i: 'user-tabs', x: 8, y: 16, w: 4, h: 8 },
      { i: 'token-details', x: 8, y: 24, w: 4, h: 8 },
      { i: 'token-distribution', x: 8, y: 32, w: 4, h: 10 },
    ],
    xxl: [
      { i: 'tradingview', x: 0, y: 0, w: 7, h: 16 },
      { i: 'orderbook', x: 7, y: 0, w: 2, h: 16 },
      { i: 'trade', x: 9, y: 0, w: 3, h: 16 },
      { i: 'token-change-stats', x: 0, y: 16, w: 8, h: 6 },
      { i: 'trades-holders', x: 0, y: 22, w: 8, h: 20 },
      { i: 'user-tabs', x: 8, y: 16, w: 4, h: 8 },
      { i: 'token-details', x: 8, y: 24, w: 4, h: 8 },
      { i: 'token-distribution', x: 8, y: 32, w: 4, h: 10 },
    ],
  } satisfies Layouts
}

export const LAYOUTS_STORAGE_KEY = localStorageKey(
  'cabana-grid-layouts-0.2',
  makeDefaultLayout() as Layouts,
)
